const connection = {
    state: () => {
        return {

            //флаг, отраэающий что в данный момент идёт переключение аккаунтов
            connectionChanging: false,

            isAuthorized: false,
        }
    },

    getters: {

        isConnectionChanging(state) {
            return state.connectionChanging;
        },

        isAuthorized(state) {
            return state.isAuthorized;
        },
    },

    mutations: {

        setConnectionChanging: (state, value) => {
            state.connectionChanging = value;
        },

        setIsAuthorized: (state, value) => {
            state.isAuthorized = value;
        }
    },
    actions: {

    }
}

export default connection;